module.exports = __webpack_public_path__ + "static/media/subNavbarTriangle.6024397b.svg";